import { Get, getAPIUrl, Post } from "../../../ApiServices/apiMethod"
import { EndPoints } from "./EndPoints"

export const getAllPlans = (param="") =>{
    const url = getAPIUrl(EndPoints.getAllPlans, param);
    return Get(url);
}
export const getMyPlans = (param="") =>{
    const url = getAPIUrl(EndPoints.getMyPlans, param);
    return Get(url);
}
export const createPlanOrder = (data, param="") =>{
    const url = getAPIUrl(EndPoints.createPlanOrder, param);
    return Post(url, data);
}
export const verifyPayment = (data, param="") =>{
    const url = getAPIUrl(EndPoints.verifyPayment, param);
    return Post(url, data);
}